export default class ExchangesModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
